export const downloadPdfBlob = (binaryData: BlobPart, filename: string) => {
  const url = window.URL.createObjectURL(new Blob([binaryData]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}.pdf`);
  link.click();
};
